import { createContext, useContext, useState, useEffect } from 'react';
import { adminAuthAPI } from './adminApi';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin,   setAdmin]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('vendly_admin_token');
    if (token) {
      adminAuthAPI.me()
        .then(res => {
          if (res.data.user?.is_admin) setAdmin(res.data.user);
          else logout();
        })
        .catch(logout)
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await adminAuthAPI.login(email, password);
    if (!res.data.user?.is_admin) throw new Error('Not an admin account');
    localStorage.setItem('vendly_admin_token', res.data.token);
    setAdmin(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('vendly_admin_token');
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
